import React from 'react';
import { Link } from 'react-router-dom';

const Contact = () => (
  <div className="min-h-screen bg-[#0e0e0e] text-white px-4 py-8">
    <div className="max-w-2xl mx-auto">
      <Link to="/login" className="text-red-500 hover:text-red-400 text-sm mb-6 inline-block">← Back to Login</Link>
      <h1 className="text-2xl font-bold text-red-500 mb-6">Contact HubTune</h1>
      <div className="text-white/80 space-y-4 leading-relaxed text-sm">
        <p>If you have any questions about your account, tips, payouts, or these policies, you can reach us using the details below.</p>
        <p className="space-y-1">
          <span className="block"><span className="font-semibold">Name:</span> Ayush Kumar</span>
          <span className="block"><span className="font-semibold">Office Address:</span> 4351, Gali Number 8, Ajit Nagar, Gandhi Nagar, East Delhi, Delhi – 110031, India</span>
          <span className="block">
            <span className="font-semibold">Email:</span>{" "}
            <a
              href="mailto:ayushk76596@gmail.com"
              className="text-red-400 hover:text-red-300 underline"
            >
              ayushk76596@gmail.com
            </a>
          </span>
          <span className="block">
            <span className="font-semibold">Phone:</span>{" "}
            <a
              href="tel:+917080176462"
              className="text-red-400 hover:text-red-300 underline"
            >
              +91 7080176462
            </a>
          </span>
        </p>
      </div>
    </div>
  </div>
);

export default Contact;

